import {
  GetWorkOrdersParams,
  WorkOrderData,
} from '../../../api/workOrders/types';

// TODO: migrar para server-side quando endpoint /work-orders aceitar
// query params para status[], sla[], evaluation_type[] e report_function[].
export const applyClientSideFilters = (
  rows: WorkOrderData[],
  filters: GetWorkOrdersParams | undefined
): WorkOrderData[] => {
  if (!filters) return rows;
  return rows.filter((row) => {
    if (filters.status && filters.status.length > 0) {
      if (!filters.status.includes(row.status)) return false;
    }
    if (filters.sla && filters.sla.length > 0) {
      if (!row.sla_status || !filters.sla.includes(row.sla_status))
        return false;
    }
    if (filters.evaluationType && filters.evaluationType.length > 0) {
      if (!filters.evaluationType.includes(row.evaluation_type)) return false;
    }
    if (filters.reportFunction && filters.reportFunction.length > 0) {
      if (!filters.reportFunction.includes(row.report_function)) return false;
    }
    return true;
  });
};
